import { Divider, Link, makeStyles, Typography } from "@material-ui/core";

interface IInfoWindow {
  data: any;
  infoWindowCallback: any;
  isSchool: boolean;
  isSelected: boolean;
  isSidePanelOpen: boolean;
}

const InfoWindow = ({
  data,
  infoWindowCallback,
  isSchool,
  isSelected,
  isSidePanelOpen,
}: IInfoWindow) => {
  const useStyles = makeStyles({
    infoWindowWrapper: {
      position: "relative",
      bottom: 90,
      left: "30px",
      width: 220,
      backgroundColor: "white",
      color: "black",
      boxShadow: "0 2px 7px 1px rgba(0, 0, 0, 0.3)",
      padding: 10,
      fontSize: 14,
      zIndex: 100,
    },
    divider: { marginBottom: 10 },
    textBold: { fontWeight: 600 },
  });

  const classes = useStyles();

  return (
    <div className={classes.infoWindowWrapper}>
      <Typography variant="subtitle2" gutterBottom>
        {isSchool ? data.name : `${data.blockNumber} ${data.street}`}
      </Typography>

      {!isSchool && (
        <>
          <Divider className={classes.divider} />
          <Typography variant="body2" gutterBottom>
            Number of Student: {data.students.length}
          </Typography>

          <Typography variant="body2" className={classes.textBold}>
            Student List
          </Typography>
          {data.students.map((student: IStudent, index: number) => {
            return (
              <Typography
                variant="body2"
                gutterBottom={data.students.length - 1 === index ? true : false}
                key={`student-${student.id}`}
              >
                - {student.firstName} {student.lastName}
              </Typography>
            );
          })}
        </>
      )}

      {!isSelected && !isSchool && isSidePanelOpen && (
        <>
          <Divider className={classes.divider} />
          <Link onClick={() => infoWindowCallback(data.postalCode)}>
            <Typography variant="body2">Add</Typography>
          </Link>
        </>
      )}
    </div>
  );
};

export default InfoWindow;
